var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRechtUndTechnik(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 457,
    height: 327,
    viewBox: "0 0 457 327",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "R&T"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M236.768 325.657L0.191162 189.341L0.229759 170.085L30.3821 160.254L236.768 270.254L267.111 304.944L236.768 325.657Z",
    fill: "#64605E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M236.773 326.21L0.195068 189.619V187.08L236.773 323.816V326.21Z",
    fill: "#826955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M456.721 199.468L236.772 326.21L236.768 284.266L431.461 169.554L456.706 179.878L456.721 199.468Z",
    fill: "#3C3839"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.195496 170.137L236.768 307.419L456.707 179.878L219.99 55.0492L0.195496 170.137Z",
    fill: "#65813F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Busch klein"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M105.934 172.391C111.542 175.54 111.542 180.734 105.934 184.018C99.6162 187.233 92.1421 187.233 85.8257 184.018C80.2184 180.87 80.2184 175.675 85.8257 172.391C92.1421 169.176 99.6162 169.176 105.934 172.391Z",
    fill: "#5B703A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M91.9809 142.843C102.407 142.843 110.858 151.662 110.858 162.541C110.858 173.421 102.407 182.24 91.9809 182.24C81.5539 182.24 73.1036 173.421 73.1036 162.541C73.1036 151.662 81.5539 142.843 91.9809 142.843Z",
    fill: "#619640"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M105.52 170.883C97.0855 175.122 87.1409 175.122 78.7079 170.883C74.8725 168.694 73.1018 165.822 73.1018 162.949C72.8045 166.957 74.9674 170.745 78.5714 172.523C87.0044 176.764 96.9479 176.764 105.382 172.523C108.501 170.76 110.588 167.605 110.991 164.043C110.281 167.026 108.274 169.536 105.52 170.883Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M103.602 158.709C96.2905 162.403 87.6586 162.403 80.3476 158.709C77.8978 157.562 76.1259 155.334 75.5591 152.69C75.1474 155.289 76.7909 158.016 80.3476 160.077C87.6586 163.772 96.2905 163.772 103.602 160.077C107.157 158.024 108.662 155.289 108.389 152.69C107.86 155.352 106.077 157.594 103.602 158.709Z",
    fill: "#D9D9D0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Busch klein_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M79.8129 184.936C83.3079 186.898 83.3079 190.135 79.8129 192.182C75.876 194.185 71.2184 194.185 67.2822 192.182C63.7879 190.22 63.7879 186.983 67.2822 184.936C71.2184 182.933 75.876 182.933 79.8129 184.936Z",
    fill: "#5B703A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M71.1152 166.524C77.6123 166.524 82.879 172.02 82.879 178.799C82.879 185.579 77.6123 191.075 71.1152 191.075C64.6175 191.075 59.3515 185.579 59.3515 178.799C59.3515 172.02 64.6175 166.524 71.1152 166.524Z",
    fill: "#558835"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M79.5552 183.999C74.2994 186.641 68.1022 186.641 62.847 183.999C60.4569 182.635 59.3534 180.845 59.3534 179.055C59.1682 181.552 60.516 183.913 62.762 185.021C68.0171 187.663 74.2136 187.663 79.4695 185.021C81.4134 183.922 82.7137 181.956 82.9645 179.736C82.5227 181.595 81.2714 183.159 79.5552 183.999Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M78.3594 176.412C73.8034 178.714 68.4242 178.714 63.8682 176.412C62.3416 175.697 61.2374 174.309 60.8842 172.661C60.6276 174.281 61.6518 175.98 63.8682 177.265C68.4242 179.567 73.8034 179.567 78.3594 177.265C80.575 175.986 81.5127 174.281 81.3426 172.661C81.0133 174.321 79.9018 175.717 78.3594 176.412Z",
    fill: "#D9D9D0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Busch klein_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M313.708 239.737C319.317 242.885 319.317 248.079 313.708 251.363C307.391 254.578 299.916 254.578 293.6 251.363C287.993 248.216 287.993 243.02 293.6 239.737C299.916 236.521 307.391 236.521 313.708 239.737Z",
    fill: "#5B703A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M299.755 210.188C310.181 210.188 318.633 219.008 318.633 229.887C318.633 240.766 310.181 249.585 299.755 249.585C289.328 249.585 280.878 240.766 280.878 229.887C280.878 219.008 289.328 210.188 299.755 210.188Z",
    fill: "#619640"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M313.294 238.229C304.86 242.468 294.915 242.468 286.482 238.229C282.647 236.039 280.876 233.167 280.876 230.294C280.579 234.302 282.742 238.09 286.346 239.869C294.779 244.109 304.722 244.109 313.156 239.869C316.276 238.105 318.362 234.951 318.765 231.388C318.056 234.371 316.048 236.881 313.294 238.229Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M311.376 226.054C304.065 229.749 295.433 229.749 288.122 226.054C285.672 224.907 283.9 222.679 283.333 220.035C282.922 222.634 284.565 225.362 288.122 227.423C295.433 231.117 304.065 231.117 311.376 227.423C314.931 225.37 316.436 222.634 316.163 220.035C315.635 222.698 313.851 224.939 311.376 226.054Z",
    fill: "#D9D9D0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Busch klein_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M287.587 252.281C291.082 254.243 291.082 257.48 287.587 259.526C283.65 261.53 278.993 261.53 275.057 259.526C271.562 257.565 271.562 254.328 275.057 252.281C278.993 250.278 283.65 250.278 287.587 252.281Z",
    fill: "#5B703A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M278.89 233.869C285.387 233.869 290.654 239.365 290.654 246.144C290.654 252.924 285.387 258.42 278.89 258.42C272.392 258.42 267.126 252.924 267.126 246.144C267.126 239.365 272.392 233.869 278.89 233.869Z",
    fill: "#558835"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M287.33 251.344C282.074 253.986 275.877 253.986 270.621 251.344C268.231 249.98 267.128 248.19 267.128 246.4C266.943 248.897 268.29 251.258 270.536 252.366C275.791 255.009 281.988 255.009 287.244 252.366C289.188 251.267 290.488 249.302 290.739 247.082C290.297 248.941 289.046 250.505 287.33 251.344Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M286.134 243.757C281.578 246.059 276.199 246.059 271.643 243.757C270.116 243.042 269.012 241.654 268.659 240.006C268.402 241.626 269.426 243.325 271.643 244.61C276.199 246.912 281.578 246.912 286.134 244.61C288.349 243.33 289.287 241.626 289.117 240.006C288.788 241.665 287.676 243.062 286.134 243.757Z",
    fill: "#D9D9D0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Waage"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fu\xC3\x83\xC5\xB8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M211.004 202.477C232.725 202.477 250.334 191.428 250.334 177.798C250.334 164.168 232.725 153.119 211.004 153.119C189.282 153.119 171.673 164.168 171.673 177.798C171.673 191.428 189.282 202.477 211.004 202.477Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M211.004 197.904C232.725 197.904 250.334 187.742 250.334 175.208C250.334 162.673 232.725 152.512 211.004 152.512C189.282 152.512 171.673 162.673 171.673 175.208C171.673 187.742 189.282 197.904 211.004 197.904Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M211.005 190.033C227.586 190.033 241.027 181.597 241.027 171.191C241.027 160.786 227.586 152.35 211.005 152.35C194.424 152.35 180.982 160.786 180.982 171.191C180.982 181.597 194.424 190.033 211.005 190.033Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M211.005 186.542C227.586 186.542 241.027 178.786 241.027 169.218C241.027 159.651 227.586 151.895 211.005 151.895C194.424 151.895 180.982 159.651 180.982 169.218C180.982 178.786 194.424 186.542 211.005 186.542Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M211.197 182.11C224.318 182.11 234.956 175.432 234.956 167.195C234.956 158.957 224.318 152.279 211.197 152.279C198.075 152.279 187.437 158.957 187.437 167.195C187.437 175.432 198.075 182.11 211.197 182.11Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M211.105 180.875C224.227 180.875 234.864 174.483 234.864 166.597C234.864 158.712 224.227 152.32 211.105 152.32C197.984 152.32 187.346 158.712 187.346 166.597C187.346 174.483 197.984 180.875 211.105 180.875Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M183.768 176.519L183.717 179.119C183.717 179.119 186.024 183.048 193.637 186.592C193.637 185.105 193.637 183.345 193.637 183.345C193.637 183.345 187.573 181.066 183.757 176.509L183.768 176.519Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M176.179 185.757L176.034 189.092C176.034 189.092 179.795 194.311 189.126 198.326C189.126 196.838 189.126 194.069 189.126 194.069C189.126 194.069 181.06 191.22 176.169 185.747L176.179 185.757Z",
    fill: "#C7C7C7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Waage_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 58",
    d: "M265.841 121.672C278.418 121.672 294.146 126.956 294.837 142.047C295.527 157.138 285.805 160.438 276.645 163.737C267.484 167.035 250.863 164.671 242.974 157.138C232.106 160.879 217.192 167.771 217.192 167.771L211.89 168.442L210.573 163.431C213.93 161.916 222.455 157.138 237.085 148.528C228.978 130.346 251.746 121.672 265.841 121.672Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Main"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Main-2",
    d: "M218.097 165.625C217.965 167.669 213.574 168.499 211.348 168.519L211.338 168.509H210.963C208.737 168.489 204.558 167.659 204.427 165.615C204.295 163.571 203.162 146.106 203.111 144.518C203.061 142.929 202.069 116.449 201.573 105.167C201.077 93.8844 198.78 76.7739 201.128 60.1289C202.322 51.7103 205.519 50.3949 206.906 42.7047C207.358 40.1926 207.594 37.641 207.672 35.1234L215.243 32.9124C215.171 36.8828 215.238 40.3809 215.587 42.6036C216.508 48.4824 220.637 51.4168 221.395 60.139C222.954 78.0792 221.446 93.8946 220.95 105.177C220.475 115.963 219.453 142.949 219.412 144.528C219.372 146.106 218.228 163.581 218.097 165.625Z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Main-3",
    d: "M221.402 60.0894C220.34 50.0518 216.026 47.9966 215.499 42.8462C215.331 41.2018 215.293 38.0172 215.348 34.2068L213.248 35.007C213.28 40.543 213.681 45.3717 214.834 47.1982C218.166 52.4799 220.122 61.6142 220.177 70.8024C220.206 75.5491 217.274 156.44 216.491 160.516C215.163 167.419 213.048 168.263 213.048 168.263C214.156 168.263 217.475 167.786 218.103 165.842C218.673 162.012 218.602 154.627 219.239 147.281C219.624 142.819 220.198 118.258 220.856 107.492C221.665 94.2667 223.193 77.0785 221.402 60.0894Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Main-4",
    d: "M202.506 60.4263C203.067 56.4449 206.897 50.6923 208.283 43.0022C208.854 39.8267 209.2 36.6504 209.387 33.5972L210.722 33.1809L210.273 42.4959C209.534 49.4271 206.295 54.4446 206.295 62.907C206.295 70.1297 205.985 98.9738 206.056 106.037C206.228 125.039 207.466 150.259 207.85 161.369C207.992 165.462 209.7 168.442 209.7 168.442C207.616 168.116 206.478 167.783 205.445 167.1C205.313 165.056 204.539 146.404 204.489 144.815C204.438 143.227 203.677 116.93 203.181 105.648C202.686 94.3656 200.158 77.0714 202.506 60.4263Z",
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 137",
    cx: 177.414,
    cy: 180.564,
    rx: 31.7841,
    ry: 21.9146,
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Teller_Links"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ring",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.684 78.5524C158.602 78.5524 160.157 76.9975 160.157 75.0795C160.157 73.1615 158.602 71.6066 156.684 71.6066C154.766 71.6066 153.212 73.1615 153.212 75.0795C153.212 76.9975 154.766 78.5524 156.684 78.5524ZM156.684 77.205C157.857 77.205 158.808 76.2541 158.808 75.0812C158.808 73.9083 157.857 72.9574 156.684 72.9574C155.512 72.9574 154.561 73.9083 154.561 75.0812C154.561 76.2541 155.512 77.205 156.684 77.205Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M154.669 168.52C170.56 168.52 183.442 160.261 183.442 150.074C183.442 139.887 170.56 131.629 154.669 131.629C138.779 131.629 125.897 139.887 125.897 150.074C125.897 160.261 138.779 168.52 154.669 168.52Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M183.499 145.333L183.44 150.072L181.24 150.309L182.319 144.577L183.499 145.333Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M125.897 145.428V150.073L127.901 150.056L127.451 145.113L125.897 145.428Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M154.89 160.74C169.894 160.74 182.057 153.672 182.057 144.952C182.057 136.233 169.894 129.165 154.89 129.165C139.886 129.165 127.723 136.233 127.723 144.952C127.723 153.672 139.886 160.74 154.89 160.74Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M154.865 161.288C169.423 161.288 181.225 155.051 181.225 147.358C181.225 139.665 169.423 133.428 154.865 133.428C140.306 133.428 128.504 139.665 128.504 147.358C128.504 155.051 140.306 161.288 154.865 161.288Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M154.669 128.697C138.763 128.722 125.88 136.213 125.897 145.427C125.914 154.641 138.822 162.089 154.729 162.063C170.635 162.038 183.518 154.548 183.501 145.333C183.484 136.119 170.576 128.671 154.669 128.697V128.697ZM154.848 160.824C139.909 160.849 127.791 153.851 127.774 145.206C127.757 136.552 139.858 129.521 154.788 129.495C169.718 129.47 181.845 136.467 181.862 145.113C181.879 153.766 169.777 160.798 154.848 160.824Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.891 77.0172C157.197 77.0864 157.375 77.3395 157.288 77.5825L136.62 133.316C136.533 133.559 136.214 133.7 135.907 133.631C135.601 133.562 135.423 133.309 135.51 133.066L156.178 77.3319C156.265 77.0889 156.584 76.948 156.891 77.0172Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.485 77.1515C156.792 77.0845 157.11 77.2275 157.195 77.4711L178.956 136.401C179.041 136.645 178.86 136.897 178.553 136.964C178.246 137.031 177.928 136.888 177.844 136.644L156.082 77.7141C155.998 77.4705 156.178 77.2186 156.485 77.1515Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.842 77.0804C157.151 77.1435 157.336 77.393 157.257 77.6376L134.227 155.696C134.147 155.941 133.833 156.088 133.524 156.025C133.216 155.962 133.03 155.713 133.11 155.468L156.14 77.4092C156.219 77.1645 156.534 77.0173 156.842 77.0804Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.571 77.1982C156.887 77.1684 157.174 77.3477 157.211 77.5985L168.565 159.667C168.603 159.918 168.377 160.145 168.06 160.175C167.744 160.205 167.457 160.025 167.42 159.775L156.066 77.7064C156.028 77.4555 156.254 77.228 156.571 77.1982Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M128.555 153.619V157.881C128.555 157.881 130.811 161.754 138.424 165.299C138.424 163.811 138.424 159.166 138.424 159.166C138.424 159.166 132.316 156.917 128.501 152.36L128.555 153.619Z",
    fill: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Teller_Rechts"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ring_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.682 27.9996C267.6 27.9996 269.155 26.4448 269.155 24.5268C269.155 22.6088 267.6 21.0539 265.682 21.0539C263.764 21.0539 262.209 22.6088 262.209 24.5268C262.209 26.4448 263.764 27.9996 265.682 27.9996ZM265.682 26.6498C266.855 26.6498 267.806 25.699 267.806 24.5261C267.806 23.3531 266.855 22.4023 265.682 22.4023C264.509 22.4023 263.558 23.3531 263.558 24.5261C263.558 25.699 264.509 26.6498 265.682 26.6498Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M263.667 117.966C279.557 117.966 292.439 109.708 292.439 99.5203C292.439 89.3332 279.557 81.0748 263.667 81.0748C247.776 81.0748 234.895 89.3332 234.895 99.5203C234.895 109.708 247.776 117.966 263.667 117.966Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M237.556 102.993V107.255C237.556 107.255 239.812 111.128 247.425 114.673C247.425 113.185 247.425 108.541 247.425 108.541C247.425 108.541 241.317 106.292 237.502 101.735L237.556 102.993Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M292.497 94.7801L292.438 99.5189L290.238 99.7567L291.317 94.0243L292.497 94.7801Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M234.895 94.8735V99.5188L236.899 99.5019L236.449 94.5593L234.895 94.8735Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M263.888 110.185C278.892 110.185 291.055 103.117 291.055 94.3977C291.055 85.6785 278.892 78.6103 263.888 78.6103C248.884 78.6103 236.72 85.6785 236.72 94.3977C236.72 103.117 248.884 110.185 263.888 110.185Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M263.862 110.734C278.421 110.734 290.223 104.498 290.223 96.8045C290.223 89.1113 278.421 82.8747 263.862 82.8747C249.304 82.8747 237.502 89.1113 237.502 96.8045C237.502 104.498 249.304 110.734 263.862 110.734Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M263.667 78.1436C247.761 78.1691 234.878 85.6594 234.895 94.8737C234.912 104.088 247.82 111.536 263.726 111.51C279.633 111.485 292.516 103.995 292.499 94.7803C292.482 85.566 279.573 78.1181 263.667 78.1436V78.1436ZM263.845 110.27C248.907 110.296 236.788 103.298 236.771 94.6529C236.754 85.9991 248.856 78.9674 263.786 78.9419C278.715 78.9164 290.843 85.9142 290.86 94.5595C290.877 103.213 278.775 110.245 263.845 110.27Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.889 26.463C266.195 26.5322 266.373 26.7853 266.285 27.0283L245.618 82.7621C245.53 83.0051 245.211 83.146 244.905 83.0768C244.599 83.0075 244.421 82.7545 244.508 82.5115L265.176 26.7777C265.263 26.5347 265.582 26.3938 265.889 26.463Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.483 26.5983C265.79 26.5312 266.107 26.6743 266.192 26.9179L287.954 85.848C288.038 86.0916 287.858 86.3434 287.551 86.4105C287.243 86.4776 286.926 86.3346 286.841 86.091L265.08 27.1609C264.995 26.9173 265.176 26.6654 265.483 26.5983Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.84 26.5258C266.148 26.5889 266.334 26.8383 266.254 27.083L243.224 105.142C243.145 105.386 242.83 105.534 242.522 105.471C242.213 105.407 242.028 105.158 242.107 104.913L265.137 26.8545C265.217 26.6099 265.532 26.4627 265.84 26.5258Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.568 26.6445C265.885 26.6148 266.171 26.794 266.209 27.0449L277.563 109.113C277.6 109.364 277.374 109.592 277.058 109.621C276.742 109.651 276.455 109.472 276.417 109.221L265.063 27.1527C265.026 26.9018 265.252 26.6743 265.568 26.6445Z",
    fill: "#A6A6A6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stange"
  }, /*#__PURE__*/React.createElement("g", {
    id: "StangeNeu"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M205.828 33.2797L209.71 35.9374L273.369 14.5105L269.497 11.8683L205.828 33.2797Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M273.795 19.6668L273.795 14.422C249.278 22.6378 211.53 35.2591 210.128 35.8599L209.023 49.1922L273.795 19.6668Z",
    fill: "#A0A0A0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "StangeNeu-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M210.148 35.8493L176.731 59.5638L148.348 71.6082L145.689 71.6777L144.586 69.4232L206.279 33.1938L208.835 33.7683L210.148 35.8493Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M210.148 35.8484L211.076 41.7813L209.045 49.1572L148.354 77.6785L148.354 71.6044L210.148 35.8484Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M144.595 69.4141L148.357 71.5991L148.357 77.655L144.595 75.5482L144.595 69.4141Z",
    fill: "#B9B9B9"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "HammerMitUnterlage"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hammer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 119",
    d: "M251.802 207.01C253.451 210.831 271.392 206.766 291.876 197.929C312.359 189.093 327.628 178.831 325.98 175.01C324.331 171.188 306.39 175.254 285.906 184.091C265.422 192.927 250.153 203.188 251.802 207.01Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Stil"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M234.738 215.334C234.738 215.334 246.524 208.587 276.369 199.389C306.213 190.192 329.743 172.363 330.513 171.263C331.694 169.612 331.967 167.085 330.376 164.678C327.279 160.002 322.59 160.174 314.085 163.887C305.58 167.601 269.952 182.524 265.999 185.051C262.046 187.578 247.945 195.194 246.61 196.192C245.275 197.189 231.127 204.039 229.741 204.469C228.355 204.898 230.751 211.896 234.721 215.334H234.738Z",
    fill: "#88573A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M234.738 215.334C234.738 215.334 246.363 208.816 276.207 199.618C306.051 190.42 329.581 172.592 330.351 171.492C331.532 169.841 331.806 167.314 330.214 164.907C327.117 160.231 322.428 160.402 313.923 164.116C305.418 167.83 269.79 182.753 265.837 185.28C261.884 187.807 247.783 195.423 246.449 196.421C245.114 197.418 231.128 204.039 229.741 204.469C228.355 204.898 230.751 211.896 234.721 215.334H234.738Z",
    fill: "url(#paint0_linear_1826_4470)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M229.535 211.385C227.997 208.453 228.127 205.348 229.825 204.449C231.522 203.551 234.145 205.2 235.682 208.132C237.219 211.063 237.089 214.169 235.392 215.067C233.695 215.965 231.072 214.317 229.535 211.385Z",
    fill: "#B0836A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M229.215 211.507C227.678 208.575 227.808 205.47 229.505 204.572C231.203 203.673 233.825 205.322 235.362 208.254C236.9 211.186 236.77 214.291 235.072 215.189C233.375 216.088 230.752 214.439 229.215 211.507Z",
    fill: "#5F3E2B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M209.517 216.375L230.57 206.816L233.466 213.255L212.414 222.814L209.517 216.375Z",
    fill: "#88573A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M229.884 211.135C228.954 209.362 229.034 207.484 230.063 206.94C231.091 206.395 232.679 207.391 233.608 209.164C234.538 210.936 234.457 212.814 233.429 213.359C232.4 213.903 230.813 212.907 229.884 211.135Z",
    fill: "#88573A"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 118",
    d: "M164.315 233.964C163.194 238.058 162.544 238.37 161.752 239.721C153.969 241.06 150.06 241.886 164.315 248.106C179.266 255.392 216.213 264.958 218.459 260.348C220.706 255.738 210.406 246.094 195.455 238.808C180.503 231.522 166.561 229.353 164.315 233.964Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Hammer-Vorne"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M163.95 234.612C158.147 231.246 158.147 220.331 163.95 210.233C169.753 200.135 179.162 194.678 184.965 198.044C190.768 201.41 190.768 212.325 184.965 222.423C179.162 232.521 169.753 237.978 163.95 234.612Z",
    fill: "#B0836A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M164.334 234.612C158.531 231.246 158.531 220.331 164.334 210.233C170.137 200.135 179.546 194.678 185.349 198.044C191.152 201.41 191.152 212.325 185.349 222.423C179.546 232.521 170.137 237.978 164.334 234.612Z",
    fill: "#5F3E2B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M167.311 240.726C159.683 236.302 158.897 223.322 165.555 211.735C172.213 200.149 183.795 194.343 191.424 198.768C199.052 203.193 199.839 216.172 193.18 227.759C186.522 239.346 174.94 245.151 167.311 240.726Z",
    fill: "#B0836A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M167.803 240.726C160.175 236.302 159.389 223.322 166.047 211.735C172.705 200.149 184.287 194.343 191.916 198.768C199.544 203.193 200.331 216.172 193.672 227.759C187.014 239.346 175.432 245.151 167.803 240.726Z",
    fill: "#88573A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M172.979 239.553C166.317 235.688 165.628 224.356 171.44 214.241C177.253 204.127 187.366 199.06 194.029 202.925C200.691 206.789 201.38 218.122 195.568 228.236C189.755 238.351 179.642 243.418 172.979 239.553Z",
    fill: "#996344"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M181.119 240.292C175.414 236.983 174.823 227.281 179.8 218.621C184.776 209.962 193.434 205.625 199.139 208.935C204.844 212.244 205.435 221.946 200.459 230.605C195.483 239.264 186.824 243.601 181.119 240.292Z",
    fill: "#5F3E2B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M182.645 242.31C176.646 238.83 176.031 228.616 181.271 219.496C186.512 210.377 195.624 205.805 201.624 209.285C207.623 212.765 208.239 222.979 202.998 232.099C197.757 241.218 188.645 245.79 182.645 242.31Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M201.625 209.283L215.161 216.865L195.995 249.807L183.314 242.637L201.625 209.283Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M196.356 250.019C191.052 246.942 191.001 237.055 196.241 227.936C201.482 218.816 210.03 213.917 215.334 216.994C220.638 220.07 220.689 229.957 215.449 239.077C210.208 248.196 201.66 253.095 196.356 250.019Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M197.757 208.129C201.935 210.454 207.36 213.742 211.242 216.07C206.274 216.588 202.237 220.473 202.237 220.473L187.937 211.699C187.937 211.699 192.195 207.938 197.757 208.129Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M177.814 234.36C181.992 236.685 187.83 240.062 192.439 242.772C192.769 247.82 195.869 249.715 195.869 249.715L183.009 242.452C183.009 242.452 178.687 240.627 177.814 234.36Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M186.044 213.35C190.222 215.674 198.209 220.163 200.824 221.805C199.28 223.427 198.519 224.485 198.519 224.485L183.929 215.634C183.929 215.634 185.05 214.28 186.044 213.35Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M199.389 252.691C193.185 249.093 192.549 238.529 197.969 229.097C203.39 219.665 212.813 214.936 219.018 218.535C225.222 222.134 225.857 232.697 220.437 242.129C215.017 251.561 205.593 256.29 199.389 252.691Z",
    fill: "#996344"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M214.939 217.38C215.281 217.38 224.71 217.569 224.71 217.569L203.507 259.296L196.559 250.047L214.939 217.38V217.38Z",
    fill: "#996344"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M205.331 260.819C197.702 256.394 196.916 243.415 203.574 231.828C210.233 220.242 221.815 214.436 229.443 218.861C237.072 223.286 237.858 236.265 231.2 247.852C224.541 259.438 212.959 265.244 205.331 260.819Z",
    fill: "#B0836A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M205.818 261.02C198.189 256.596 197.403 243.616 204.061 232.029C210.72 220.443 222.302 214.637 229.93 219.062C237.559 223.487 238.345 236.466 231.687 248.053C225.028 259.64 213.446 265.445 205.818 261.02Z",
    fill: "#88573A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M210.908 261.619C204.041 257.636 203.335 245.947 209.332 235.512C215.329 225.077 225.757 219.846 232.625 223.83C239.492 227.813 240.198 239.502 234.201 249.937C228.204 260.372 217.776 265.603 210.908 261.619Z",
    fill: "#5F3E2B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M212.962 261.558C207.159 258.192 207.158 247.277 212.962 237.179C218.765 227.081 228.173 221.624 233.977 224.99C239.78 228.356 239.78 239.271 233.977 249.369C228.174 259.467 218.765 264.925 212.962 261.558Z",
    fill: "#B0836A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M213.432 262.061C207.629 258.694 207.629 247.779 213.432 237.681C219.235 227.583 228.644 222.126 234.447 225.492C240.25 228.858 240.25 239.773 234.447 249.871C228.644 259.969 219.235 265.427 213.432 262.061Z",
    fill: "#88573A"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Baum"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M372.689 164.26C357.75 164.26 345.641 169.841 345.641 176.726C345.641 183.611 357.75 189.192 372.689 189.192C387.627 189.192 399.737 183.611 399.737 176.726C399.737 169.841 387.627 164.26 372.689 164.26Z",
    fill: "#5B703A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M352.667 180.18L355.463 158.27C355.451 158.729 355.582 159.18 355.84 159.56C356.097 159.94 356.467 160.23 356.898 160.389C357.963 160.922 359.135 161.206 360.327 161.219C361.518 161.232 362.696 160.974 363.773 160.464C364.178 160.291 364.527 160.008 364.78 159.648C365.034 159.288 365.182 158.864 365.208 158.424L368.23 181.019C368.381 182.303 367.626 183.588 365.963 184.569C364.23 185.445 362.316 185.9 360.374 185.9C358.432 185.9 356.518 185.445 354.784 184.569C352.667 183.429 351.987 181.688 352.667 180.18Z",
    fill: "#816955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M378.43 119.135C367.539 119.135 358.711 128.336 358.711 139.685C358.711 151.035 367.539 160.235 378.43 160.235C389.32 160.235 398.148 151.035 398.148 139.685C398.148 128.336 389.32 119.135 378.43 119.135Z",
    fill: "#558835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M350.326 115.508C340.646 115.508 332.799 123.694 332.799 133.791C332.799 143.889 340.646 152.075 350.326 152.075C360.006 152.075 367.854 143.889 367.854 133.791C367.854 123.694 360.006 115.508 350.326 115.508Z",
    fill: "#619640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M337.859 141.498C344.734 145.426 355.84 145.426 362.716 141.498C366.192 139.459 367.929 136.814 367.854 134.17C368.307 137.041 366.645 140.819 362.793 143.085C355.919 147.014 344.812 147.014 337.937 143.085C336.519 142.295 335.312 141.176 334.417 139.821C333.523 138.467 332.968 136.917 332.798 135.303C333.175 137.57 334.837 139.761 337.859 141.498Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M365.284 132.433C356.564 132.433 349.494 139.772 349.494 148.827C349.494 157.881 356.564 165.221 365.284 165.221C374.005 165.221 381.075 157.881 381.075 148.827C381.075 139.772 374.005 132.433 365.284 132.433Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M354.028 155.777C360.223 159.328 370.197 159.328 376.388 155.777C379.565 153.963 381.071 151.541 380.996 149.204C381.374 151.773 379.862 155.174 376.463 157.213C370.268 160.763 360.295 160.763 354.103 157.213C352.82 156.506 351.73 155.496 350.926 154.272C350.123 153.047 349.632 151.644 349.495 150.186C349.796 152.226 351.312 154.191 354.028 155.777Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M355.614 145.728C358.609 147.255 361.923 148.051 365.284 148.051C368.646 148.051 371.96 147.255 374.954 145.728C375.955 145.253 376.834 144.557 377.527 143.694C378.22 142.83 378.709 141.821 378.956 140.741C379.259 142.933 377.897 145.2 374.954 146.937C371.96 148.464 368.646 149.26 365.284 149.26C361.923 149.26 358.609 148.464 355.614 146.937C352.672 145.275 351.378 143.008 351.613 140.741C351.837 142.555 353.195 144.292 355.614 145.728Z",
    fill: "#D9D9D0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1826_4470",
    x1: 306.184,
    y1: 170.323,
    x2: 309.917,
    y2: 178.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#955E3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88573A",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRechtUndTechnik);
export default __webpack_public_path__ + "static/media/RechtUndTechnik.620d9ca70460d7828566843454123540.svg";
export { ForwardRef as ReactComponent };